/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectChangeOrderQuery } from '../../models/get-project-change-order-query';
import { GetProjectChangeOrderQueryResult } from '../../models/get-project-change-order-query-result';

export interface ApiProjectChangeOrderGetProjectChangeOrderPost$Plain$Params {
      body?: GetProjectChangeOrderQuery
}

export function apiProjectChangeOrderGetProjectChangeOrderPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderGetProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderGetProjectChangeOrderPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectChangeOrderQueryResult>;
    })
  );
}

apiProjectChangeOrderGetProjectChangeOrderPost$Plain.PATH = '/api/ProjectChangeOrder/GetProjectChangeOrder';
